import styled from "styled-components";

export const AllActivitiesWrapper = styled.div`
  .nav-tabs {
    display: flex;
    justify-content: space-evenly;
    border: none;
    li {
      button {
        border: none;
        color: ${({ theme }) => theme.text};
        border-radius: 6px;
      }
      .active {
        background-color: ${({ theme }) => theme.box};
        color: ${({ theme }) => theme.text};
      }
    }
  }
  @media (max-width: 576px) {
    .nav-tabs {
      flex-wrap: nowrap;
      li {
        button {
          padding: 8px;
          font-size: 14px;
        }
      }
    }
  }
  .tab-content {
    .tab-pane {
      border: none;
    }
  }
`;
